import { render, staticRenderFns } from "./Organizations.vue?vue&type=template&id=bad27c20&scoped=true"
import script from "./Organizations.vue?vue&type=script&lang=ts"
export * from "./Organizations.vue?vue&type=script&lang=ts"
import style0 from "./Organizations.vue?vue&type=style&index=0&id=bad27c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad27c20",
  null
  
)

export default component.exports